/**
 * OwnYou Spacing System — Sprint 14 Production Design System
 *
 * Spacing scale from xs through 2xl. Also retains card-specific
 * dimensions and breakpoints from the existing design system.
 *
 * @see docs/sprints/ownyou-sprint14-spec.md Package 1
 */
/**
 * Spacing scale — used for padding, margins, gaps
 */
export const spacing = {
    xs: 4, // 0.25rem — micro spacing (icon padding, badge inner)
    sm: 8, // 0.5rem  — tight spacing (between related items)
    md: 16, // 1rem    — standard spacing (card padding, list gaps)
    lg: 24, // 1.5rem  — section spacing
    xl: 32, // 2rem    — major section breaks
    '2xl': 48, // 3rem   — page-level spacing
};
/**
 * Card dimension values (retained for mission card layout)
 */
export const cardDimensions = {
    width: '180px',
    widthTablet: '220px',
    widthDesktop: '260px',
    gap: '13px',
    feedPadding: '10px',
    overlapMargin: '-13px',
};
/**
 * Card height values by type
 */
export const cardHeights = {
    shopping: '290px',
    savings: '284px',
    consumables: '284px',
    content: '284px',
    travel: '208px',
    entertainment: '207px',
    food: '287px',
    people: '210px',
    health: '180px',
};
/**
 * Breakpoint values for responsive design
 */
export const breakpoints = {
    mobile: '640px',
    tablet: '768px',
    desktop: '1024px',
    desktopMd: '1280px',
    desktopLg: '1440px',
    ultraWide: '1920px',
};
/**
 * Masonry grid column configuration per breakpoint
 */
export const masonryColumns = {
    default: 4,
    1440: 4,
    1280: 3,
    1024: 3,
    768: 2,
    640: 2,
};
/**
 * CSS custom property tokens for spacing
 */
export const spacingTokens = {
    '--spacing-xs': `${spacing.xs}px`,
    '--spacing-sm': `${spacing.sm}px`,
    '--spacing-md': `${spacing.md}px`,
    '--spacing-lg': `${spacing.lg}px`,
    '--spacing-xl': `${spacing.xl}px`,
    '--spacing-2xl': `${spacing['2xl']}px`,
    '--card-width': cardDimensions.width,
    '--card-width-desktop': cardDimensions.widthDesktop,
    '--card-gap': cardDimensions.gap,
    '--feed-padding': cardDimensions.feedPadding,
};
//# sourceMappingURL=spacing.js.map